<micro-lookup domain="webclient" obj="webClientConfigs" url="/web/clients" [key]="webClientConfigId" [link]="link"></micro-lookup>
